import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import { Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import './SignatureNotification.scss';

const assetsBaseUrl = `${process.env.REACT_APP_DOMAIN}/assets/media`;
class SignatureNotification extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      target: document.getElementById('signaturenotification-ui'),
      documentCount: get(window, 'asure.appSettings.esignature.employeePendingDocCount'),
    };
  }

  render() {
    const { target, documentCount } = this.state;
    const componentContent = (
      <Row className="pb-3 w-100" id="signature-notification">
        <div className="notification-banner d-flex align-items-center mx-4 w-100">
          <div className="px-4">
            <img src={`${assetsBaseUrl}/signature.svg`} alt="" className="pl-2" />
          </div>
          <div>
            <h5 className="m-0 mb-1"><FormattedMessage id="SIGNATURE_NEEDED" /></h5>
            <div className="pad-for-mobile"> <FormattedMessage id="YOU_HAVE" />
              <strong>&nbsp;
                <FormattedMessage
                  id="DOCUMENT_COUNT"
                  values={{
                    documentCount,
                    documentPlural: documentCount > 1 ? 's' : '',
                  }}
                />&nbsp;
              </strong>
              <FormattedMessage
                id="NEED_TO_BE_SIGNED"
                values={{
                  documentSingular: documentCount > 1 ? '' : 's',
                }}
              />
            </div>
            <div className="pt-3" id="show-for-mobile">
              <a
                href={`${window.location.origin}/Secure/Employee/EmployeeDocumentList.aspx?menu=ESS`}
                className="btn btn-primary"
              ><FormattedMessage id="GO_TO_DOCUMENTS" />
              </a>
            </div>
          </div>
          <div className="d-flex ml-auto pr-3" id="hide-for-mobile">
            <a
              href={`${window.location.origin}/Secure/Employee/EmployeeDocumentList.aspx?menu=ESS`}
              className="btn btn-primary"
            ><FormattedMessage id="GO_TO_DOCUMENTS" />
            </a>
          </div>
        </div>
      </Row>
    );
    if (target && documentCount > 0) {
      return createPortal(componentContent, target);
    }
    return null;
  }
}
export default (SignatureNotification);




// WEBPACK FOOTER //
// ./src/containers/SignatureNotification/SignatureNotification.jsx